// extracted by mini-css-extract-plugin
export default {"socialLinkIcons":"SocialMediaLinks_socialLinkIcons__wTfLN","iconLink":"SocialMediaLinks_iconLink__fSi3+","icon":"SocialMediaLinks_icon__csDm6"};